import React from 'react';
import { motion } from 'framer-motion';
import profileImage from '../images/profile.jpeg'; // Replace with your image path

function About() {
  return (
    <section className="about">
      <motion.div
        className="about-content"
        initial={{ x: -200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="about-image">
          <img src={profileImage} alt="About Me" />
        </div>
        <div className="about-text">
          <h2>About Me</h2>
          <p>
            Hello! I'm Vignesh M, a passionate Full Stack Developer with hands-on experience building scalable, real-world web applications. I recently completed my B.Tech in Computer Science and Business Systems from Sri Eshwar College of Engineering with a CGPA of 8.28.
            <br /><br />
            My core skills lie in <strong>Node.js, React.js, FastAPI, Django, PostgreSQL, MongoDB, SQL and Tailwind CSS</strong>. I’ve developed and deployed full-stack systems like the <strong>KSD Quail Management System</strong> and <strong>Live Polling Platform</strong> that solve domain-specific problems using modern backend logic and responsive frontends.
            <br /><br />
            I’ve interned across multiple domains, contributed to team-based software projects, and regularly upskill myself through coding platforms like LeetCode and HackerRank. I also explore <strong>AI integration, automation pipelines, serverless functions</strong>, and tools like <strong>Docker, AWS, and GitHub Actions</strong>.
            <br /><br />
            I believe in building efficient, accessible, and purpose-driven software. Outside of code, I recharge through solo travel, mountain trekking, meditation, and quiet time in nature — all of which shape my calm and focused mindset.
          </p>
        </div>
      </motion.div>
    </section>
  );
}

export default About;
